import toast from 'Shared/toast';
import { useMutation } from 'react-query';
import CompanyService from 'App/services/CompanyService';

const useGenerateActivityMobileLinksMutation = () => {
    return useMutation((branchId) => CompanyService.generateActivityMobileLinks(branchId), {
        onSuccess: (data) => {
            if (data?.downloadId) {
                toast.success('Mobile activity links generated successfully.');
            } else {
                toast.success('No new patient activities since last generation. No links were created.');
            }
        },
    });
};

export default useGenerateActivityMobileLinksMutation;
